const featureAnnouncementContent = require.context('./content', false, /\.md$/);

export default featureAnnouncementContent;
